const url = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant`;

export const fetchMultitenant = async ({
  path,
  method = "GET",
  body,
  redirect = "follow",
  token,
}) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Access-Control-Allow-Origin", "*");
  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }

  const requestOptions = {
    method,
    headers,
    body,
    redirect,
  };

  try {
    const res = await fetch(`${url}/${path}`, requestOptions);
    return res.json();
  } catch (error) {
    console.error("error", error);
  }
};
